module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-02.3e4419b5.jpg";